"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Arrows = _interopRequireDefault(require("./Arrows"));
var _Wrapper = _interopRequireWildcard(require("./Wrapper"));
var _Pagination = _interopRequireDefault(require("./Pagination"));
var _PaginationWrapper = _interopRequireDefault(require("./Pagination/PaginationWrapper"));
var _FlexboxWrapper = _interopRequireDefault(require("./FlexboxWrapper"));
var _SwipeWrapper = _interopRequireDefault(require("./SwipeWrapper"));
var _Arrow = _interopRequireDefault(require("./Arrows/Arrow"));
var _Box = _interopRequireDefault(require("../Box"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var Carousel = function Carousel(_ref) {
  var arrows = _ref.arrows,
    alwaysShowArrows = _ref.alwaysShowArrows,
    children = _ref.children,
    clickRightArrowInLastPosition = _ref.clickRightArrowInLastPosition,
    customLeftArrow = _ref.customLeftArrow,
    customLeftArrowLabel = _ref.customLeftArrowLabel,
    customRightArrow = _ref.customRightArrow,
    customRightArrowLabel = _ref.customRightArrowLabel,
    dotsColor = _ref.dotsColor,
    flex = _ref.flex,
    initialIndex = _ref.initialIndex,
    onChange = _ref.onChange,
    outsideArrows = _ref.outsideArrows,
    pagination = _ref.pagination,
    paginationClickable = _ref.paginationClickable,
    paginationWrapper = _ref.paginationWrapper,
    slideSize = _ref.slideSize,
    swipe = _ref.swipe,
    visibleItems = _ref.visibleItems,
    paginationDelta = _ref.paginationDelta,
    swipeProps = _ref.swipeProps,
    showArrowsOnHover = _ref.showArrowsOnHover,
    maxNumberOfDots = _ref.maxNumberOfDots,
    bottomArrows = _ref.bottomArrows,
    keepMounted = _ref.keepMounted;
  var _useState = (0, _react.useState)(visibleItems),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  var _useState3 = (0, _react.useState)(initialIndex),
    _useState4 = _slicedToArray(_useState3, 2),
    index = _useState4[0],
    setIndex = _useState4[1];
  var shouldMountInSSR = keepMounted && typeof window === 'undefined';
  var childrenCount = children.length;
  var handleChangeIndex = (0, _react.useCallback)(function (eventIndex) {
    var newIndex = eventIndex;
    if (eventIndex >= childrenCount) {
      newIndex = childrenCount - 1;
    } else if (eventIndex < 0) {
      newIndex = 0;
    }
    setLoaded(function (oldLoaded) {
      var newTotal = newIndex + paginationDelta + visibleItems;
      if (newTotal > oldLoaded) {
        return newTotal;
      }
      return oldLoaded;
    });
    setIndex(newIndex);
    if (typeof onChange === 'function') {
      onChange(newIndex);
    }
  }, [childrenCount, paginationDelta, setIndex, onChange]);
  var handleClickChangeIndex = (0, _react.useCallback)(function (event, newIndex) {
    if (event) {
      event.preventDefault();
    }
    handleChangeIndex(newIndex);
  }, [handleChangeIndex]);
  (0, _react.useEffect)(function () {
    handleChangeIndex(initialIndex);
  }, [initialIndex]);
  var itemsWithKeys = _react["default"].Children.map(children, function (child, i) {
    return /*#__PURE__*/_react["default"].isValidElement(child) ? /*#__PURE__*/_react["default"].cloneElement(child, {
      key: child.props.id ? child.props.id : "".concat(i)
    }) : child;
  });
  var itemsMemo = (0, _react.useMemo)(function () {
    return itemsWithKeys.slice(0, loaded);
  }, [loaded, itemsWithKeys]);
  var items = shouldMountInSSR ? itemsWithKeys : itemsMemo;
  var arrowsProps = {
    index: index,
    onChangeIndex: handleClickChangeIndex,
    onClickRightArrowInLastPosition: clickRightArrowInLastPosition,
    slideCount: childrenCount,
    visibleItems: visibleItems,
    customLeftArrow: customLeftArrow,
    customLeftArrowLabel: customLeftArrowLabel,
    customRightArrow: customRightArrow,
    customRightArrowLabel: customRightArrowLabel,
    showArrows: alwaysShowArrows,
    outsideArrows: outsideArrows,
    paginationDelta: paginationDelta,
    bottomArrows: bottomArrows
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Wrapper.OuterWrapper, {
    showArrowsOnHover: showArrowsOnHover
  }, !flex && arrows && !bottomArrows && /*#__PURE__*/_react["default"].createElement(_Arrows["default"], arrowsProps), !flex && pagination && /*#__PURE__*/_react["default"].createElement(_Pagination["default"], {
    paginationWrapper: paginationWrapper,
    index: index,
    dotsColor: dotsColor,
    onChangeIndex: handleClickChangeIndex,
    slideCount: childrenCount,
    clickable: paginationClickable,
    visibleItems: visibleItems,
    maxNumberOfDots: maxNumberOfDots
  }), /*#__PURE__*/_react["default"].createElement(_Wrapper["default"], {
    visibleItems: visibleItems,
    slideSize: slideSize
  }, swipe ? /*#__PURE__*/_react["default"].createElement(_SwipeWrapper["default"], _extends({
    index: index,
    onChangeIndex: handleChangeIndex,
    slideSize: slideSize,
    ignoreNativeScroll: true
  }, swipeProps), items) : /*#__PURE__*/_react["default"].createElement(_FlexboxWrapper["default"], {
    index: index,
    slideSize: slideSize,
    flex: flex,
    slideCount: items.length
  }, items))), !flex && !arrows && bottomArrows && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex",
    mt: 2,
    gridgap: 2,
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react["default"].createElement(_Arrows["default"], _extends({}, arrowsProps, {
    bottomArrows: bottomArrows
  }))));
};
Carousel.propTypes = process.env.NODE_ENV !== "production" ? {
  arrows: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired,
  customLeftArrow: _propTypes["default"].elementType,
  customLeftArrowLabel: _propTypes["default"].object,
  customRightArrow: _propTypes["default"].elementType,
  customRightArrowLabel: _propTypes["default"].object,
  dotsColor: _propTypes["default"].string,
  flex: _propTypes["default"].bool,
  initialIndex: _propTypes["default"].number,
  pagination: _propTypes["default"].bool,
  paginationClickable: _propTypes["default"].bool,
  paginationWrapper: _propTypes["default"].object,
  slideSize: _propTypes["default"].string,
  swipe: _propTypes["default"].bool,
  alwaysShowArrows: _propTypes["default"].bool,
  visibleItems: _propTypes["default"].number,
  clickRightArrowInLastPosition: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  outsideArrows: _propTypes["default"].bool,
  paginationDelta: _propTypes["default"].number,
  swipeProps: _propTypes["default"].object,
  showArrowsOnHover: _propTypes["default"].bool,
  maxNumberOfDots: _propTypes["default"].number,
  bottomArrows: _propTypes["default"].bool,
  keepMounted: _propTypes["default"].bool
} : {};
Carousel.defaultProps = {
  arrows: false,
  customLeftArrow: _Arrow["default"],
  customRightArrow: _Arrow["default"],
  flex: false,
  initialIndex: 0,
  pagination: false,
  paginationClickable: true,
  paginationWrapper: _PaginationWrapper["default"],
  slideSize: '100%',
  swipe: false,
  visibleItems: 1,
  alwaysShowArrows: true,
  outsideArrows: false,
  paginationDelta: 1,
  swipeProps: {},
  showArrowsOnHover: false,
  bottomArrows: false,
  keepMounted: false
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Carousel);